import { render, staticRenderFns } from "./PFormSelectMulti.vue?vue&type=template&id=ea71f072&scoped=true"
import script from "./PFormSelectMulti.vue?vue&type=script&lang=ts"
export * from "./PFormSelectMulti.vue?vue&type=script&lang=ts"
import style0 from "./PFormSelectMulti.vue?vue&type=style&index=0&id=ea71f072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea71f072",
  null
  
)

export default component.exports